<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.groupBuying') }}</div>
        <div v-loading="loading">
          <div class="goods-grid" v-if="list.length">
            <div class="goods-card" v-for="(item, index) in list" :key="(item.marketingId || '') + '-' + (item.goodsId || item.id || '') + '-' + index" @click="goDetail(item)">
              <img :src="(item.goods && item.goods.thumbnail) || item.image" class="goods-img" />
              <div class="goods-name">{{ (item.goods && item.goods.name) || item.name }}</div>
              <div class="price-row">
                <span class="group-price">¥{{ item.marketingPrice }}</span>
                <span class="origin-price" v-if="item.goods && item.goods.marketPrice">¥{{ item.goods.marketPrice }}</span>
              </div>
              <div class="group-info">
                <span class="min-people">{{ item.requiredNum }}{{ $t('message.home.people') }}{{ $t('message.home.groupBuying') }}</span>
                <span class="joined">{{ $t('message.home.joined') }}：{{ item.joinCount || 0 }}</span>
              </div>
              <el-button type="danger" size="small" style="width:100%;margin-top:10px">
                {{ $t('message.home.startGroup') }}
              </el-button>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
        </div>
        <el-pagination v-if="total > 0" background layout="prev, pager, next"
          :total="total" :page-size="queryParams.pageSize"
          @current-change="(p) => { queryParams.pageNumber = p; loadData() }"
          style="margin-top:32px;text-align:center" />
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { list } from '@/api/marketing/group_marketing'

export default {
  name: 'GroupPage',
  data() {
    return { loading: false, list: [], total: 0, queryParams: { pageNumber: 1, pageSize: 20 } }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      list(this.queryParams).then(r => {
        const data = r.data?.data
        this.list = Array.isArray(data) ? data : (data?.content || [])
        this.total = Array.isArray(data) ? data.length : (data?.total || 0)
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    goDetail(item) {
      this.$router.push({ path: '/productDetails', query: {
        id: item.goodsId,
        marketingId: item.marketingId,
        marketingModeId: 'groupMarketing'
      }})
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 24px; }
.goods-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 16px; }
.goods-card { background: #fff; border-radius: 8px; overflow: hidden; padding: 12px; cursor: pointer; transition: box-shadow .2s; &:hover { box-shadow: 0 4px 16px rgba(0,0,0,.1); } }
.goods-img { width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 4px; }
.goods-name { font-size: 13px; color: #303133; margin: 8px 0 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.price-row { display: flex; align-items: baseline; gap: 8px; }
.group-price { font-size: 18px; font-weight: bold; color: #f56c6c; }
.origin-price { font-size: 12px; color: #c0c4cc; text-decoration: line-through; }
.group-info { display: flex; justify-content: space-between; margin-top: 6px; font-size: 12px; color: #909399; }
</style>
